var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWasap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8264 38.7988C30.4928 38.7988 39.139 30.1525 39.139 19.4861C39.139 8.81975 30.4928 0.173462 19.8264 0.173462C9.15996 0.173462 0.513672 8.81975 0.513672 19.4861C0.513672 30.1525 9.15996 38.7988 19.8264 38.7988ZM28.9091 24.1598L26.6148 21.8616C25.85 21.093 24.3204 21.093 23.5556 21.8616L22.0261 23.3931C19.2817 23.003 16.2902 19.9439 15.9059 17.2613L17.4354 15.7279C18.2002 14.9612 18.2022 13.4297 17.4354 12.663L15.1276 10.4478C14.3628 9.68303 12.8487 9.59419 12.082 10.3609C10.5524 11.8943 10.17 13.0454 10.17 14.5769C10.17 16.8751 10.5524 19.5595 15.1411 24.156C19.7317 28.7601 21.6437 29.1425 24.7009 29.1425C25.485 29.1425 27.4298 28.7099 28.9091 27.2267C29.6739 26.46 29.6739 24.9265 28.9091 24.1598Z",
    fill: "#1C6A3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasap);
export default __webpack_public_path__ + "static/media/wasap.592757cfe1d79e2d19835be9a90f98f3.svg";
export { ForwardRef as ReactComponent };